import { AuthenticationManager } from "@core/managers/authentication.manager";
import { NotificationsManager } from "../managers/notifications.manager";
import { useProfileStore } from "@etab/stores/profile";
/**
 * Check whether the user has activated push notifications or not
 * This navigation guard is called before each route change
 * but will be executed only once after the user is authentified OR on specific routes
 */
export function setupProfileLoadGuard({ storeAction, storeGetter } = {}) {
  return async (to, from, next) => {
    const store = useProfileStore();
    const userIsAuthenticated = await AuthenticationManager.isUserAuthenticated();

    if (userIsAuthenticated && !store[storeGetter].isProfileLoaded()) {
      // if profile data is not set
      try {
        await store[storeAction]();
      } catch (error) {
        NotificationsManager.error({ message: "ERRORS.@SOMETHING_WENT_WRONG" });
      }
    }

    return next();
  };
}
